import { useLocalSearchParams } from "expo-router";
import Head from "expo-router/head";

import Redirect from "@/components/BreadcrumbRedirect";
import { brandName } from "@/config/brand";
import { UseCase, useUseCaseSuggestions } from "@/hooks/suggestions";
import UseCaseLayoutV3 from "@/landing-page/v3/UseCaseLayoutV3";

export default function UseCaseLanding() {
  const { useCase } = useLocalSearchParams();
  const { prompts, pageTitle } = useUseCaseSuggestions(useCase as UseCase);

  if (!prompts || prompts.length === 0) {
    return (
      <Redirect
        href="/"
        reason="Use case does not exist"
        context={{
          useCase,
          promptsLength: prompts?.length,
        }}
      />
    );
  }

  return (
    <>
      <Head>
        <title>{`${pageTitle} — ${brandName}`}</title>
      </Head>
      <UseCaseLayoutV3 />
    </>
  );
}
